import Cell from "./Cell";
import { IDataGridColumn, IDataGridFocusedCell } from "./type/IDataGridProps";
import styles from "./DataGrid.module.css";
interface IRowProps {
  rowData: any;
  rowIndex: number;
  stickyOffsets: any;
  dataColumns: IDataGridColumn[];
  focusedCell?: IDataGridFocusedCell;
  mainColor?: string;
}
const Row = (props: IRowProps) => {
  const { rowData, rowIndex, dataColumns } = props;

  return (
    <tr key={rowIndex} className={rowIndex % 2 === 0 ? styles.even : ""}>
      {dataColumns.map((column: IDataGridColumn, colIndex: number) => {
        return (
          <Cell
            key={colIndex}
            column={column}
            colIndex={colIndex}
            rowData={props.rowData}
            rowId={rowData["id"]}
            rowIndex={rowIndex}
            stickyOffsets={props.stickyOffsets}
            focusedCell={props.focusedCell}
            mainColor={props.mainColor}
          />
        );
      })}
    </tr>
  );
};

export default Row;
